import { render, staticRenderFns } from "./MealPlan.vue?vue&type=template&id=10a2bf5e&scoped=true&"
import script from "./MealPlan.vue?vue&type=script&lang=js&"
export * from "./MealPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2bf5e",
  null
  
)

export default component.exports